import RangeOfNumber from '@/commons/wildcards/constants/RangeOfNumber';

export default {
  Search: {
    SearchPlaceHolder: 'Tìm kiếm',
    AddButton: 'Thêm mới',
    AddButtonShortKey: 'Thêm mới (F9)',
    SubmitButton: 'Chọn',
    SubmitButtonShortKey: 'Chọn (Ctrl + S)',
    CancelButton: 'Hủy',
  },
  Validate: {
    ShortKey: '{0} phải có độ dài {1}',
    Duplicate: '{0} này đã tồn tại trong hệ thống. Vui lòng nhập lại.',
    DuplicateVoucher: '{0} đã tồn tại trong hệ thống. Vui lòng chọn lại.',
    DeleteArise: '{0} này đã phát sinh dữ liệu. Bạn không thể xóa!',
    DuplicateName: '{0} đã bị trùng trong danh sách nhập. Vui lòng kiểm tra lại.',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác. Xin vui lòng nạp lại.',
    DeleteMultiHasMultiArisened: 'Có một số bản ghi xuất hiện lỗi trong quá trình xóa.', // Chi tiết xem phía dưới: "[ {0} ]
    DeleteMultiHasMultiArisened2: 'Có một số bản ghi đã có phát sinh. Không thể xóa.',
    ConfirmDeleteMultiHasMultiArisened: 'Có một số bản ghi đã có phát sinh. Bạn có muốn tiếp tục xóa không?',
    DeleteMultiHasOneArisened: 'Có một bản ghi đã có phát sinh. Không thể xóa.', // <{0}>
    DeleteMultiHasOneArisenedComponentAsset: 'Linh kiện đã có phát sinh, bạn không thể xóa.', // <{0}>
    NotPermission: 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại quyền của bạn.',
    TitleNotPermission: 'Không được phân quyền',
    ManagerUnitHasArise: 'Đơn vị quản lý đã có phát sinh dữ liệu, bạn không thể bỏ check là đơn vị quản lý.',
    ParentUnitHasArise:
      'Đơn vị quản lý cấp cha của đơn vị này đã có phát sinh dữ liệu đã, bạn không thể đặt là đơn vị quản lý.',
    ManagerUnitHasDependent:
      'Đơn vị đã có phát sinh đơn vị con là đơn vị quản lý, bạn không thể bỏ check là đơn vị quản lý.',
    NewMessageDelete: '{0} <{1}> đã có phát sinh. Bạn có muốn tiếp tục xóa không?',
    Required: 'Nhập thiếu thông tin {0}.',
    Arise:
      '{0} đã phát sinh dữ liệu. Do vậy, để thêm mới được {0} <span class="color-green">{1}</span>, hệ thống phải chuyển toàn bộ dữ liệu gắn với {0} <span class="color-green">{2}</span> sang cho {0} <span class="color-green">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    AriseAccount:
      'Hệ thống không cho phép hạch toán vào TK tổng hợp. Do vậy, để thêm mới TK <span class="color-green">{1}</span>, hệ thống phải chuyển toàn bộ dữ liệu gắn với TK <span class="color-green">{2}</span> sang TK <span class="color-green">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    StartThanEndDate: 'Ngày kết thúc phải lớn hơn Ngày bắt đầu.',
    Delete_ErrorIsPostedVoucher: 'Chứng từ này có liên quan đến chứng từ {0}. Bạn có muốn xóa không?',
    StartWithOther: 'Số tài khoản chi tiết không được bắt đầu bằng số hiệu của tài khoản con cùng cấp.',
    AriseOpeningEntry1:
      'Tài khoản đã phát sinh trong chứng từ, số dư ban đầu. Bạn cần khai báo lại số dư ban đầu cho tài khoản này tại Tùy chọn nghiệp vụ/Nhập số dư ban đầu. Bạn có muốn thay đổi không?',
    AriseOpeningEntry2: 'Tài khoản đã phát sinh số dư ban đầu. Bạn có muốn thay đổi không?',
    RegisterMisaID: 'Lỗi đăng ký tài khoản MISA ID',
    AriseProject:
      'Dự án/Công trình tổng hợp đã có phát sinh dữ liệu. Do vậy để {0} Công trình/HMCT <span class="color-green">{1}</span> hệ thống phải chuyển toàn bộ dữ liệu gắn với Dự án/Công trình <span class="color-green">{2}</span> sang cho Công trình/HMCT <span class="color-green">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    AriseCtmtDa:
      '{0} đã phát sinh dữ liệu. Do vậy, để thêm mới được {1} <span class="color-green">{2}</span>, hệ thống phải chuyển toàn bộ dữ liệu gắn với {0} <span class="color-green">{3}</span> sang cho {1} <span class="color-green">{2}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    ComparitionAccount: 'Chọn tài khoản không hợp lệ. Tài khoản cũ và Tài khoản mới không được trùng nhau.',
    MustEqualCategoryAccount: 'Chọn tài khoản không hợp lệ. Phải cùng tính chất.',
    HaveIsDetailUnequal: 'Tài khoản {0} có thông tin chi tiết theo khác tài khoản {1}',
    UnAcceptAccount: 'Tài khoản không hợp lệ',
    FromDateMustLargerThanCloseDate: 'Từ ngày phải lớn hơn ngày khóa sổ {0}',
    DaterageUnaccept: 'Kỳ báo cáo không hợp lệ',
    Save_VoucherInvalidDate: 'Ngày hạch toán phải lớn hơn ngày khóa sổ. Xin vui lòng kiểm tra lại.',
    Save_VoucherInvalidDateTitle: 'Ngày hạch toán không hợp lệ',
    Save_PostingDateLessThanRefDate: 'Ngày hạch toán không được nhỏ hơn ngày chứng từ. Vui lòng kiểm tra lại.',
  },
  Detail: {
    SubmitError: 'Đã có lỗi xảy ra, vui lòng liên hệ MISA để được hỗ trợ.',
    AddDetail: 'Thêm dòng',
    SaveSuccessMessage: 'Cất dữ liệu thành công',
  },
  Message: {
    ConfirmDeleteTitle: 'Xóa {0}',
    ConfirmDeleteVoucherTitle: 'Xóa chứng từ',
    ConfirmDeleteRelatedVoucherTitle: 'Xóa chứng từ liên quan',
    ConfirmDeleteRelatedVoucherMessage:
      'Chứng từ {0} được sinh đồng thời với {1} <<span class="color-green">{2}</span>>. Bạn  có muốn xóa tất cả các chứng từ liên quan này không?',
    ConfirmChangeTitle: 'Dữ liệu đã thay đổi',
    ConfirmDeleteVoucher: 'Bạn có muốn xóa chứng từ <span class="color-green">{0}</span> không?',
    ConfirmDelete: 'Bạn có muốn xóa {0} <span class="color-green">{1}</span> không?',
    ConfirmDeleteCustom: 'Bạn có muốn xóa <span class="color-green">{0} {1}</span> không?',
    ConfirmDeleteMuti: 'Bạn có chắc chắn muốn xóa các bản ghi {0} được chọn không?',
    ConfirmDeleteMutiVoucher: 'Bạn có thực sự muốn xóa các chứng từ đã chọn không?',
    ConfirmDeleteMutiCheckCloseBook:
      'Không thể xóa chứng từ <span class="color-green">{0}</span>. Bạn có muốn thực hiện xóa các chứng từ còn lại không?',
    ConfirmPostedMutiCheckCloseBook:
      'Không thể ghi sổ chứng từ <span class="color-green">{0}</span>. Bạn có muốn thực hiện ghi sổ các chứng từ còn lại không?',
    ConfirmUnPostedMutiCheckCloseBook:
      'Không thể bỏ ghi chứng từ <span class="color-green">{0}</span>. Bạn có muốn thực hiện bỏ ghi các chứng từ còn lại không?',
    ConfirmDeleteMutiReally: 'Bạn có thực sự muốn xóa các <span class="color-green">{0}</span> đã chọn không?',
    ConfirmDeleteMutiCustom: 'Bạn có muốn xóa các <span class="color-green">{0}</span> đã chọn không?',
    ConfirmDeleteUser: 'Bạn có thực sự muốn xóa {0} <span class="color-green">{1}</span> không?',
    ConfirmDeleteMultiUser: 'Bạn có thực sự muốn xóa những {0} đã chọn không?',
    ConfirmSaveChangeClose: 'Bạn có muốn Cất không?',
    ConfirmSaveBeforeClose: 'Bạn có muốn lưu thông tin đang thay đổi không?',
    ConfirmSaveChangeCloseCCDC: 'Dữ liệu đã bị thay đổi, bạn có muốn cất không?',
    NotSelected: 'Vui lòng chọn <span class="color-green">ít nhất 1 bản ghi</span> để thực hiện được chức năng này.',
    Exception: 'Đã có lỗi xảy ra, vui lòng liên hệ MISA để được hỗ trợ.',
    //#region Thành công
    ExportSuccess: 'Xuất khẩu thành công',
    DeleteSuccess: 'Xóa thành công',
    RejectSuccess: 'Từ chối duyệt thành công',
    GetDefaultSuccess: 'Lấy lại dữ liệu mặc định thành công',
    //#endregion
    SendApprovalSuccess: 'Gửi duyệt hồ sơ giao dịch KBNN thành công!',
    ApprovalSuccess: 'Ký duyệt hồ sơ giao dịch KBNN thành công!',
    WarningTitle: 'Cảnh báo',
    SaveSuccess: 'Cất dữ liệu thành công',
    PostedSuccess: 'Ghi sổ thành công',
    SavePostedSuccess: 'Cất và ghi sổ thành công',
    UnPostedSuccess: 'Bỏ ghi sổ thành công',
    GenerateVoucherParalellSuccess: 'Sinh chứng từ ghi đồng thời thành công',
    Developing: 'Chức năng đang được phát triển.',
    DeleteWarningTitle: 'Không thể xóa',
    WarningBatchExcution: 'Không hợp lệ',
    ValidatePostedDate: 'Ngày hạch toán không hợp lệ',
    ValidateInvalidTitle: 'Không hợp lệ',
    ValidateAmountContent: 'Số ký tự cột thành tiền vượt quá số lượng quy định (14 ký tự). Vui lòng kiểm tra lại.',
    ValidateInvalidAccountTitle: 'Số tài khoản không hợp lệ',
    ValidatePostedDateIsBeforeRefDate: 'Ngày hạch toán không được nhỏ hơn ngày chứng từ. Vui lòng kiểm tra lại.',
    ValidatePostedDateMustAfterDateClosed: 'Ngày hạch toán phải lớn hơn ngày khóa sổ. Xin vui lòng kiểm tra lại.',
    ValidateOrgVoucherDate: 'Ngày chứng từ gốc không được lớn hơn ngày hạch toán. Vui lòng kiểm tra lại.',
    ValidateTotalAmountOutOfRange: 'Tổng số tiền của chứng từ vượt quá giới hạn 18 ký tự.',
    FailSave: 'Cất không thành công',
    FailSaveRealNameTitle: 'Chưa xác định đích danh chứng từ nhập',
    ArrriseAccount: 'Tài khoản đã có phát sinh',
    ArrriseOpeningAccount: 'Tài khoản đã có số dư ban đầu',
    ValidateBusinessTitle: 'Chứng từ không hợp lệ',
    ValidateBusiness: 'Vui lòng nhập ít nhất một dòng chứng từ chi tiết.',
    ValidateNotTyping: 'Vui lòng nhập ít nhất một dòng dữ liệu chi tiết.', // modified: vqphong - 27.10.2022
    ValidateLeastAnAccount: 'Bạn cần chọn ít nhất một Tài khoản.',
    ValidateLeastAFund: 'Bạn cần chọn ít nhất một Quỹ tiền.',
    ErrorSystemDeleteMulti: '{0} đã chọn là dữ liệu thuộc hệ thống.',
    ConfirmErrorSystemDelete: '{0} <span class="color-green">{1}</span> đã chọn là dữ liệu thuộc hệ thống.',
    ConfirmErrorDeleteTitle: 'Không thể xóa',
    WarningIncurredDataTitle: 'Xóa không thành công',
    WarningPostedIncurredDataTitle: 'Ghi sổ không thành công',
    WarningUnpostedIncurredDataTitle: 'Bỏ ghi sổ không thành công',
    WarningIncurredDataContent:
      '{0} <span class="color-green">{1}</span> đã có phát sinh dữ liệu. Bạn phải xóa các phát sinh liên quan trước khi xóa.',
    WarningIncurredDataContentCustom:
      '{0} <span class="color-green">{1}</span> đã có số dư ban đầu; đã phát sinh trên các chứng từ. Bạn phải xóa các phát sinh liên quan trước khi sửa thông tin chi tiết theo.',
    WarningArriseAccount:
      '{0} <span class="color-green">{1}</span> đã phát sinh trên các chứng từ. Bạn có muốn thay đổi không?',
    WarningArriseOpeningAccount:
      '{0} <span class="color-green">{1}</span> đã có số dư ban đầu. Bạn phải xóa số dư ban đầu trước khi sửa thông tin chi tiết theo.',
    WarningParallelNotValidRule:
      '<div class="content-toast"><div class="text-toast">Không tự động sinh được hạch toán đồng thời. <a class="help-view-here" href="">Xem hướng dẫn</a></br>hoặc kiểm tra lại quy tắc <a class="help-view-here">Thiết lập hạch toán đồng thời</a>.</div><div class="icon-close"></div></div>',

    WarningParallelNotAutoGenerate:
      'Thông tin hạch toán đồng thời không phù hợp với quy tắc thiết lập hạch toán đồng thời. Bạn có muốn cập nhật hạch toán đồng thời không?',

    DeleteRelation:
      'Chứng từ số <span class="color-green">{0}</span> có liên quan đến chứng từ số <span class="color-green">{1}</span>. Bạn có muốn xóa chứng từ liên quan này không?',
    DeleteRelationVoucherSummary:
      'Chứng từ <span class="color-green">{0}</span> đã được lập Bảng tổng hợp chứng từ cùng loại <span class="color-green">{1}</span>. Để xóa <span class="color-green">{0}</span>, chương trình sẽ loại bỏ <span class="color-green">{0}</span> khỏi Bảng tổng hợp chứng từ cùng loại. Bạn có muốn xóa không?',
    DeleteRelationVoucherSummaryMulti:
      '- Bảng tổng hợp <span class="color-green">&lt;{1}&gt;</span> đã được kê trong Chứng từ ghi sổ <span class="color-green">&lt;{0}&gt;</span> </br>',
    ConfirmDeleteRelationVoucherSummaryMulti:
      'Chương trình sẽ loại bỏ các bảng tổng hợp dưới đây ra khỏi chứng từ ghi sổ, bạn có thực sự muốn xóa không? </br>',
    ConfirmDeleteRelationVoucherSummary:
      'chương trình sẽ loại bỏ bảng tổng hợp này ra khỏi chứng từ ghi sổ, bạn có thực sự muốn xóa không?',
    DeleteRelationTitle: 'Xóa chứng từ',
    DeleteRelationMulti:
      'Chứng từ số <span class="color-green">{0}</span> có liên quan đến chứng từ số <span class="color-green">{1}</span>. </br>',
    ConfirmDeleteRelation: 'Bạn có muốn xóa chứng từ liên quan này không?',
    GetDefaultSettingLayoutSuccess: 'Lấy tùy chỉnh giao diện mặc định thành công',
    OverloadUpdate: `Tổng {0} trên thông tin chung, không cập nhật được do Tổng {0} theo nguồn vượt quá ${RangeOfNumber.MaxCountNumber} ký tự.`,
    TitleChangePostedDate: 'Chuyển năm hạch toán',
    ContentChangePostedDate:
      'Năm hạch toán vừa chuyển sang năm <span class="color-green">{0}</span> nên sẽ không thấy các chứng từ của năm cũ. Để xem lại các chứng từ của năm cũ, vui lòng chuyển lại ngày hạch toán.',
    ValidateOutwardQuantityTitle: 'Xuất kho quá số lượng tồn kho',
    ValidateOutwardQuantityContent:
      'Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số tồn trong kho <span class="color-green">{2}-{3}</span>. Số tồn tính đến ngày {4}: {5}. Ghi sổ không thành công.',
    ValidateOutwardQuantityRealNameContent:
      'Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số lượng tồn của chứng từ <span class="color-green">{2}</span>. Số lượng tồn của chứng từ <span class="color-green">{2}</span> là: {3}. Ghi sổ không thành công.',
    ValidateZeroQuantityRealNameContent:
      'Số tồn của Vật tư <span class="color-green">{0}-{1}</span> = 0. Vui lòng chọn Vật tư khác.',
    ValidateNotChooseInventoryRealNameContent: 'Vui lòng chọn Mã hàng trước khi chọn chứng từ Mua, Nhập VTHH.',
    ValidateUndefinedVoucherRealNameContent:
      'Vật tư <span class="color-green">{0}-{1}</span> chưa xác định đích danh chứng từ nhập. Ghi sổ không thành công.',
    ValidatePostedValueMustNotBeZero: 'Giá trị hạch toán phải khác 0.',
    ExpireReportDrillDown: 'Báo cáo cũ đã hết hạn, vui lòng in lại báo cáo.',
    TimeoutStockPrice:
      'Quá trình tính giá xuất kho có thể kéo dài phụ thuộc vào độ lớn của dữ liệu. Trong thời gian tính giá bạn vẫn có thể làm việc trên phần mềm. Để tránh sai sót bạn không nên sửa chứng từ thuộc kỳ tính giá.<br>Khi quá trình tính giá hoàn thành, hệ thống sẽ gửi kết quả trên chức năng <b>Thông báo</b>.',
    StockPriceRequest: 'Yêu cầu tính giá xuất kho',
    ConfirmDeleteReportTitle: 'Xóa báo cáo',
    ConfirmDeleteReport: 'Bạn có muốn xóa báo cáo này không?',
    ReplacementInvoiceExists:
      'Hóa đơn <span class="color-blue">{0} - {1} - {2}</span> đã được lập hóa đơn thay thế. Vui lòng kiểm tra lại.',

    WarningNoDataWhenSaveDvcFile:
      '<div class="content-toast"><div class="text-toast">Chưa chọn mẫu chứng từ thanh toán. <a class="link-view-here ml-2">Thêm mẫu chứng từ</a>.</div><div class="icon-close"></div></div>',
    TaxRateCheckTitle: 'Thuế suất không hợp lệ',
    TaxRateCheckContent:
      '<span class="color-green">Thuế suất</span> không đúng. Vui lòng chọn <span class="color-green">Thuế suất</span> có trong danh sách.',
    Unachievable: 'Không thể thực hiện',
    SaveDataSuccess: 'Lưu dữ liệu thành công',
    ValidateAccountError: `Tài khoản hạch toán không hợp lệ`,
    SaveDataExpense: 'Cất dữ liệu thành công. Bạn có muốn sinh chứng từ nhận dự toán {0} không?',
    SaveDataAdjustExpense: 'Cất dữ liệu thành công. Bạn có muốn sinh chứng từ điều chỉnh dự toán không?',
    SaveEditDataExpense:
      'Cất dữ liệu thành công. Đã tồn tại chứng từ nhận dự toán {0} cho nghiệp vụ này, bạn có muốn cập nhật lại chứng từ nhận dự toán {1} không?',
    SaveEditAdjustExpense:
      'Cất dữ liệu thành công. Đã tồn tại chứng từ điều chỉnh dự cho nghiệp vụ này, bạn có muốn cập nhật lại chứng từ điều chỉnh dự toán không?',
    AriseEditParentRecord:
      '{0} tổng hợp đã phát sinh dữ liệu. Bạn vui lòng xóa dữ liệu đã phát sinh ở {0} tổng hợp trước khi sửa, hoặc chọn lại {0} tổng hợp khác.',
    CantDeleteParallelVoucher: 'Không thể xóa chứng từ Ghi sổ đồng thời',
    CantDeleteSalagovVoucher: 'Không thể xóa hàng loạt do chứng từ được sinh từ Salagov',
    BudgetChapter: 'Chương <span class="color-green">{0}</span> chưa được tích theo dõi.',
    budgetSubKindItem: 'Khoản <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetItem: 'Mục <span class="color-green">{0}</span> chưa được tích theo dõi.',
    budgetSubItem: 'Tiểu mục <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetKindItem: 'Loại <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetProject: 'Chương trình mục tiêu, dự án <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetSource: 'Nguồn kinh phí <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetProvideCode: 'Mã dự phòng <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetDetailItem: 'Tiết tiểu mục <span class="color-green">{0}</span> chưa được tích theo dõi.',
    ForceSelectionValidate: '<span class="color-green">{0}</span> không có trong danh mục. Vui lòng kiểm tra lại.',
    ConfirmErrorActiveTitle: 'Không thể ngừng theo dõi',
    BudgetChapterErrorDefault: ' <span class="color-green">Chương - {0}</span> được thiết lập mặc định.',
    budgetSubKindItemErrorDefault: '<span class="color-green">Loại khoản - {0}</span> được thiết lập mặc định.',
    BudgetProjectErrorDefault:
      '<span class="color-green">Chương trình mục tiêu, dự án - {0}</span> được thiết lập mặc định.',
    BudgetSourceErrorDefault: '<span class="color-green">Nguồn kinh phí - {0}</span> được thiết lập mặc định.',
    FundNameErrorDefault: '<span class="color-green">Quỹ tiền - {0}</span> được thiết lập mặc định.',
    BudgetItemDebit: 'Mục nợ <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetItemCredit: 'Mục có <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetSubItemDebit: 'Tiểu mục nợ <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetSubItemCredit: 'Tiểu mục có <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetSubKindItemDebit: 'Khoản nợ <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetSubKindItemCredit: 'Khoản có <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetKindItemDebit: 'Loại nợ <span class="color-green">{0}</span> chưa được tích theo dõi.',
    BudgetKindItemCredit: 'Loại có <span class="color-green">{0}</span> chưa được tích theo dõi.',
    WarningTitleUpdateVoucher: 'Đồng bộ chứng từ',
    WarningContentUpdateVoucher:
      'Bạn có muốn đồng bộ các thông tin trên chứng từ chi tiền gửi với chứng từ hạch toán chi phí lương, bảo hiểm, KPCĐ số <span class="color-green">{0}</span> không?',
    ProcessPosted: 'Đang thực hiện Ghi sổ/ Bỏ ghi chứng từ',
  },
  MessageDeleteParentNode: {
    DeleteWarningParentTitle: 'Xóa không thành công',
    DeleteWarningParentContent: 'Không thể xóa danh mục cha nếu chưa xóa danh mục con.',
    DeleteWarningParentContentCustom: 'Vui lòng xóa hết nội dung con trước khi thực hiện xóa nội dung cha.',
  },
  Voucher: {
    GenerateVoucher:
      'Không sinh được giấy rút dự toán từ hạch toán chi tiết của chứng từ này. Vui lòng kiểm tra lại dữ liệu cột TK Có và cột Nghiệp vụ.',
    GenerateVoucherTitle: 'Không hợp lệ',
    ConfirmSyncVocherContent:
      'Bạn có muốn đồng bộ các thông tin đã cập nhật trên chứng từ {0} này sang giấy rút dự toán số <span class="color-green">{1}</span> không?',
    ConfirmSyncVocherTitle: 'Đồng bộ chứng từ',
    ConfirmSyncFundSalaryContent:
      'Bạn có muốn đồng bộ các thông tin đã cập nhật trên chứng từ {0} này sang Chứng từ nghiệp vụ khác số <span class="color-green">{1}</span> không?',
  },
  BUPlanReceipt: {
    ValidateWarningAccountPostedTitle: 'Ghi sổ chứng từ',
    ValidateWarningAccountPostedMessage:
      'Tài khoản hạch toán không phù hợp với nguồn phát sinh. Bạn có muốn kiểm tra thông tin trước khi ghi sổ không?',
  },
  INAdjustmentDetail: {
    WarningGenerateOutward:
      'Chương trình đã sinh phiếu xuất kho <span class="color-green">{0}</span> để xử lý chênh lệch. Bạn không thể sinh thêm.',
    WarningGenerateInward:
      'Chương trình đã sinh phiếu nhập kho <span class="color-green">{0}</span> để xử lý chênh lệch. Bạn không thể sinh thêm.',
    TitleConfirmEditAdjustment: 'Sửa chứng từ',
    ConfirmEditAdjustment:
      'Điều chỉnh tồn kho đã có chứng từ xử lý chênh lệch <span class="color-green">&lt;{0}&gt;</span>. Bạn có muốn sửa không?',
    ValidateActionInWard: 'Bạn phải có ít nhất một vật tư, hàng hóa có hành động xử lý là Nhập Kho.',
    ValidateActionOutWard: 'Bạn phải có ít nhất một vật tư, hàng hóa có hành động xử lý là Xuất Kho.',
    ValidateNewQuantityAndAmonntControlGrid: 'Không thể điều chỉnh vừa tăng vừa giảm cho 1 vật tư trong kho.',
    validateDuplicateInventoryItemCodeGrid: 'Mã hàng đã có trong danh sách. Xin vui lòng kiểm tra lại.',
  },
  DefaultValue: {
    All: 'Tất cả',
  },
  Notification: {
    StartCalculateExportStock: 'Bắt đầu thực hiện tính giá xuất kho từ ngày <b>{0}</b> đến ngày <b>{1}</b>',
    CompleteCalculateExportStock: 'Hoàn thành việc Tính giá xuất kho từ ngày <b>{0}</b> đến ngày <b>{1}</b>',
    PostbathStatus:
      '<span class="color-green">{0}</span> {1} chứng từ ngày <b>{2}</b> đến <b>{3}</b> của các phân hệ <b>{4}</b>',
    CompleteCalculatePrice: 'Hoàn thành việc Tính giá xuất kho',
    PostbathTypeStatus: '{0} {1} chứng từ ngày <b>{2}</b> đến <b>{3}</b> của các phân hệ <b>{4}</b>.',
    StartCloseBook: 'Bắt đầu khóa sổ kỳ kế toán',
    CompleteCloseBook: 'Đã hoàn thành khóa sổ kỳ kế toán',
    NotPostedCloseBook: 'Khóa sổ kế toán không thành công do có chứng từ chưa được ghi sổ.',
    RebuildStatus: '<span class="color-green"><b>{0}</b></span> bảo trì dữ liệu từ ngày <b>{1}</b> đến ngày <b>{2}</b>',
    ErrorMes: 'Có một số lỗi đã xảy ra trong quá trình {0}',
    ConvertDataError:
      'Có một số lỗi đã xảy ra trong quá trình chuyển đổi dữ liệu từ <b>MISA Panda 2022 {0}</b> vào dữ liệu <b>{1}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    CompleteConvertData:
      '<b><span class="color-green">Đã hoàn thành</span></b> chuyển đổi dữ liệu từ <b>MISA Panda 2022 {0}</b> vào dữ liệu <b>{1}</b>',
    WarningExpiredDate:
      '<b>Thời hạn sử dụng còn {0} ngày</b><br><span>Kính đề nghị Quý khách hàng đăng ký gia hạn thuê bao</span>',
    EndCreateData: '<b><span class="color-green">Đã hoàn thành</span></b> thêm mới dữ liệu <b>{0}</b> từ <b>{1}</b>',
    ErrorCreateData: 'Có lỗi xảy ra khi tạo dữ liệu',
    CompleteRestoreData: '<b><span class="color-green">Đã hoàn thành</span></b> phục hồi <b>{0}</b>.',
    CompleteBackupData: '<b><span class="color-green">Đã hoàn thành</span></b> sao lưu <b>{0}</b>.',
    ErrorRestoreData:
      'Có một số lỗi đã xảy ra trong quá trình phục hồi dữ liệu <b>{0}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    ErrorBackupData:
      'Có một số lỗi đã xảy ra trong quá trình sao lưu dữ liệu <b>{0}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    ErrorUnfolowState: `<span class="bold color-green">{0} - {1}</span> được thiết lập mặc định.`,
  },
  FormState: {
    Add: 'Thêm {0}',
    Edit: 'Sửa {0}',
  },

  TooltipButton: {
    SaveButton: 'Cất (Ctrl + S)',
    PostponeButton: 'Hoãn (Ctrl + U)',
    EditButton: 'Sửa (Ctrl + E)',
    RefreshButton: 'Nạp (Ctrl + R)',
    CloseButton: 'Đóng (ESC)',
    CloseButtonDVC: 'Đóng (Esc)',
    OtherCancelButton: 'Hủy (ESC)',
  },
  Button: {
    SaveButton: 'Cất',
    CancelButton: 'Hủy',
    CloseButton: 'Đóng',
    AddDictionaryButton: 'Thêm mới danh mục',
  },
  Toast: {
    IsFromSalagov: 'Chứng từ gốc bên SalaGov',
  },
};
